<script lang="ts">
	import {
		min,
		max,
		from,
		to,
		selectedObjectTypes,
		resetDateRange,
		selectedArtistTitles,
		selectedArtistCountries,
		selectedAwardYears,
		selectedAwardCountries,
	} from '../stores/filter';
	import ResetButton from './ResetButton.svelte';
</script>

<div class="filter__active">
	{#each [...$selectedObjectTypes] as item}
		<ResetButton
			{item}
			reset={() => {
				selectedObjectTypes.remove(item);
			}}
		/>
	{/each}
	{#if $from > $min || $to < $max}
		<ResetButton
			item={`${$from ?? ''}${$from && $to ? '–' : ''}${$to ?? ''}`}
			reset={() => {
				resetDateRange();
			}}
		/>
	{/if}
	{#each [...$selectedArtistTitles] as item}
		<ResetButton
			{item}
			reset={() => {
				selectedArtistTitles.remove(item);
			}}
		/>
	{/each}
	{#each [...$selectedArtistCountries] as item}
		<ResetButton
			{item}
			reset={() => {
				selectedArtistCountries.remove(item);
			}}
		/>
	{/each}
	{#each [...$selectedAwardYears] as item}
		<ResetButton
			{item}
			reset={() => {
				selectedAwardYears.remove(item);
			}}
		/>
	{/each}
	{#each [...$selectedAwardCountries] as item}
		<ResetButton
			{item}
			reset={() => {
				selectedAwardCountries.remove(item);
			}}
		/>
	{/each}
</div>
